(function () {
  var fired = false;
  var queued = [];
  var seen = new WeakSet();
  var placeholderMap = new WeakMap();

  var blockedSrcSubstrings = [
    "gorgias",
    "yotpo",
    "wrapped-app-embed",
    "acsbapp",
    "visually",
    "3265aeeaf73a1d19"
  ];

  function normalize(value) {
    return String(value || "").toLowerCase();
  }

  function isScript(node) {
    return node && node.nodeType === 1 && node.tagName === "SCRIPT";
  }

  function isBlockedBySrcValue(src) {
    src = normalize(src);
    if (!src) return false;

    return blockedSrcSubstrings.some(function (fragment) {
      return src.indexOf(normalize(fragment)) !== -1;
    });
  }

  function getNodeSrc(node) {
    if (!node) return "";
    return node.getAttribute("src") || node.src || "";
  }

  function isBlockedBySrc(node) {
    return isBlockedBySrcValue(getNodeSrc(node));
  }

  function shouldIgnore(node) {
    if (!isScript(node)) return true;
    // if (node.dataset.deferManaged === "true") return true;
    // if (node.dataset.deferAllow === "true") return true;
    // if (node.hasAttribute("data-keep-critical")) return true;
    // if (node.type === "application/ld+json") return true;
    // if (node.type === "application/json") return true;
    // if (node.noModule) return true;
    if (node.classList && node.classList.contains("ignore")) return true;

    return false;
  }

  function shouldDelay(node) {
    if (shouldIgnore(node)) return false;

    var src = getNodeSrc(node);

    /* More consistent behavior:
       only delay external scripts with a matching src */
    if (!src) return false;

    return isBlockedBySrcValue(src);
  }

  function cloneScript(original) {
    var s = document.createElement("script");

    for (var i = 0; i < original.attributes.length; i++) {
      var attr = original.attributes[i];

      if (attr.name === "async" || attr.name === "defer") continue;

      s.setAttribute(attr.name, attr.value);
    }

    s.dataset.deferManaged = "true";

    if (original.src || original.getAttribute("src")) {
      s.async = false;
      s.src = getNodeSrc(original);
    } else {
      s.textContent = original.textContent;
    }

    return s;
  }

  function enqueue(node) {
    if (seen.has(node)) return;
    if (!node.parentNode) return;

    seen.add(node);
    node.dataset.deferManaged = "true";

    var placeholder = document.createComment("deferred-script");
    placeholderMap.set(node, placeholder);

    queued.push({
      original: node,
      placeholder: placeholder
    });

    node.parentNode.replaceChild(placeholder, node);
  }

  function flushQueue() {
    while (queued.length) {
      var item = queued.shift();
      var original = item.original;
      var placeholder = item.placeholder;

      if (!placeholder || !placeholder.parentNode) continue;

      var script = cloneScript(original);
      placeholder.parentNode.replaceChild(script, placeholder);
    }
  }

  function activate() {
    if (fired) return;
    fired = true;

    flushQueue();

    setTimeout(function () {
      observer.disconnect();
    }, 2000);
  }

  function scanNode(node) {
    if (!node) return;

    if (shouldDelay(node)) {
      enqueue(node);
      return;
    }

    if (node.querySelectorAll) {
      var scripts = node.querySelectorAll("script");
      for (var i = 0; i < scripts.length; i++) {
        if (shouldDelay(scripts[i])) {
          enqueue(scripts[i]);
        }
      }
    }
  }

  function handleAttributeMutation(target) {
    if (fired) return;
    if (!isScript(target)) return;
    if (shouldDelay(target)) enqueue(target);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      if (mutation.type === "childList") {
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          scanNode(mutation.addedNodes[j]);
        }
      }

      if (mutation.type === "attributes") {
        handleAttributeMutation(mutation.target);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["src", "type", "data-keep-critical", "data-defer-allow"]
  });

  ["scroll", "mousemove", "keydown"].forEach(function (eventName) {
    window.addEventListener(eventName, activate, { once: true, passive: true });
  });

  if (document.readyState === "complete") {
    setTimeout(activate, 6000);
  } else {
    window.addEventListener("load", function () {
      setTimeout(activate, 6000);
    }, { once: true });
  }
})();